import { Observable } from 'rxjs';
import { PermsService } from './../../../../services/utils/perms.service';
import { PermissionConfiguration, ApiMethods } from './../../../../models/permission.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/components/common/api';
import { StoreModel } from '../../../../models/store-common.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CountryService } from '../../../../services/country/country.service';
import { DivisionSalesNetworkService } from '../../../../services/division-sales-network/divison-sales-network.service';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { ProvinceService } from '../../../../services/province/province.service';
import { StateService } from '../../../../services/state/state.service';
import { ToponymService } from '../../../../services/toponym/toponym.service';
import { StoreCommonService } from './../../../../services/store/store-common.service';

@Component({
  selector: 'app-kv-store-common-basic',
  templateUrl: './store-common-basic.component.html',
  providers: []
})
export class StoreCommonBasicComponent implements OnInit {

  // Disabilita i campi Codice Host, Canale Loyalty e Rete di Vendita
  public disableFieldsPermission: boolean;
  public disableFieldsPermissionCheck: PermissionConfiguration;

  @Input() storeId: string;
  @Input() editMode: boolean;
  @Input() validationForm: boolean;

  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  validators = {
    date_start: KoncentroValidators.checkDateMajorOther('date_end'),
    date_end: KoncentroValidators.checkDateMinorOther('date_start'),
    phone: KoncentroValidators.phone,
    email: KoncentroValidators.emailOrEmpty,
    latitude: KoncentroValidators.latitude,
    longitude: KoncentroValidators.longitude,
    store_surface: KoncentroValidators.numberNotNegative,
    checkouts_number: KoncentroValidators.numberNotNegative
  }

  store: StoreModel;
  formBasic: FormGroup;
  provinces: SelectItem[];
  countries: Array<any>;
  states: SelectItem[];
  toponyms: SelectItem[];
  channels: SelectItem[];
  division_sales_networks: SelectItem[];

  model = {
    country: null,
    state: null
  }

  fields: any;
  public invalidSubmit: boolean;

  validationData = null;

  constructor(
    private fb: FormBuilder,
    private countryService: CountryService,
    private provinceService: ProvinceService,
    private toponymService: ToponymService,
    private stateService: StateService,
    private srvStore: StoreCommonService,
    private channelService: LoyaltyChannelService,
    private divisionSalesNetworksService: DivisionSalesNetworkService,
    protected srvCalendarTranslate: CalendarTranslateService,
    private permSrv: PermsService) {

    this.disableFieldsPermissionCheck = {
      ms_base: 'koncentro-common',
      operation: 'ui-store-disable-fields',
      method: ApiMethods.POST
    }

  }

  ngOnInit(): void {

    this.disableFieldsPermission = false;

    if (this.editMode) {
      let obDisableFieldsPermCheck: Observable<any>;
      obDisableFieldsPermCheck = this.permSrv.check(this.disableFieldsPermissionCheck);
      obDisableFieldsPermCheck.subscribe(res => this.disableFieldsPermission = res);
    }

    this.loadProvinces();
    this.loadToponyms();
    this.loadChannels();
    this.loadDivisionSalesNetworks();
    this.loadValidation();
  }

  loadValidation() {
    this.srvStore.getFields().subscribe(res => {
      this.fields = res
    });
  }

  loadProvinces() {
    this.provinceService.getAll().subscribe(res => {
      this.provinces = [];
      for (const province of res) {
        this.provinces.push({ label: province.name, value: province.id });
      }
    });
  }

  loadToponyms() {
    this.toponymService.getAll().subscribe(res => {
      this.toponyms = [];
      for (const toponym of res) {
        this.toponyms.push({ label: toponym.name, value: toponym.id });
      }
    });
  }

  loadChannels() {
    this.channelService.list().subscribe(res => {
      this.channels = [];
      for (const channel of res.data) {
        this.channels.push({ label: `(${channel.channel_code}) ${channel.channelDescription}` , value: channel.id });
      }
    });
  }

  loadDivisionSalesNetworks() {
    this.divisionSalesNetworksService.list().subscribe(res => {
      this.division_sales_networks = [];
      for (const dsn of res) {
        this.division_sales_networks.push({ label: `${dsn.sales_network_name} - ${dsn.division_name}`, value: dsn.id });
      }
    });
  }

  replaceComma(stringControlName: string) {
    let value = this.formBasic.get(stringControlName).value.replace(',', '.');
    this.formBasic.get(stringControlName).setValue(value);
  }

  /*** Gestione autocomplete Countries */
  filterCountrySingle(event) {
    if (event) {
      let search = [
        {key: 'name', value: event.query},
        {key: 'flg_state', value: '0'}
      ];
      this.countryService.list(null, null, search).subscribe(res => {
        this.countries = [];
        if (res && res.data) {
          this.countries = res.data;
        }
      })
    }
  }

  onSelectCountry(event) {
    this.formBasic.get('country_id').setValue(event.id);
    this.model.state = null;
    this.formBasic.get('state_id').setValue(null);
    let search = [
      {key: 'country_id', value: event.id.toString()},
      {key: 'flg_state', value: '0'}
    ];

    this.stateService.list(null, null, search).subscribe(res => {
      this.states = [];
      if (res && res.data) {
        for (const state of res.data) {
          this.states.push({ label: state.name, value: state.id });
        }
      }
    });

    this.provinceService.getAll(event.id).subscribe(res => {
      this.provinces = [];
      for (const province of res) {
        this.provinces.push({ label: province.name, value: province.id });
      }
    });

  }

  onClearCountry() {
    this.formBasic.get('country_id').setValue(null);
    this.formBasic.get('state_id').setValue(null);
    this.formBasic.get('province_id').setValue(null);
    this.provinces = [];
    this.states = [];
    this.model.country = null;
    this.model.state = null;
  }

  /*** Gestione autocomplete States */
  filterStateSingle(event) {
    if (event) {
      let search = [
        {key: 'name', value: event.query},
        {key: 'country_id', value: this.model.country.id.toString()}
      ];
      this.stateService.list(null, null, search).subscribe(res => {
        this.states = [];
        if (res && res.data) {
          this.states = res.data;
        }
      })
    }
  }

  onSelectState(event) {
    this.formBasic.get('state_id').setValue(event.value);

    this.provinceService.getAll(this.model.country.id, event.value).subscribe(res => {
      this.provinces = [];
      for (const province of res) {
        this.provinces.push({ label: province.name, value: province.id });
      }
    });
  }

  onClearState() {
    this.formBasic.get('state_id').setValue(null);
    this.model.state = null;
    this.formBasic.get('province_id').setValue(null);
    this.provinces = [];
  }

  createForm(res: StoreModel) {
    if (res.country_id) {
      let search = [
        {key: 'id', value: res.country_id.toString()},
        {key: 'flg_state', value: '0'}
      ];
      this.countryService.list(null, null, search).subscribe( res1 => {
        this.countries = [];
        if (res1 && res1.data) {
          this.countries = res1.data;
        }
        this.model.country = res1.data[0];
      });
    }

    if (res.state_id) {
      let search = [
        {key: 'country_id', value: res.country_id.toString()},
        {key: 'flg_state', value: '0'}
      ];
      this.stateService.list(null, null, search).subscribe( res2 => {
        this.states = [];
        if (res2 && res2.data) {
          for (const state of res2.data) {
            this.states.push({ label: state.name, value: state.id });
          }
        }
        this.model.state = this.states.filter( s => s.value === res.state_id)[0].value;
        if (res.country_id) {
          this.provinceService.getAll(res.country_id, res.state_id).subscribe(res3 => {
            this.provinces = [];
            for (const province of res3) {
              this.provinces.push({ label: province.name, value: province.id });
            }
            this.formBasic.get('province_id').setValue(res.province_id);
          });
        }
      });
    }

    this.formBasic = this.fb.group({
      address_1: [res.address_1 || null],
      address_2: [res.address_2 || null],
      address_number: [res.address_number || null],
      altitude: [res.altitude || null],
      city: [res.city || null],
      channel_loyalty_id: [res.channel_loyalty_id || null],
      code: [res.code || null],
      contact_1: [res.contact_1 || null],
      contact_2: [res.contact_2 || null],
      date_start: [res.date_start || null],
      date_end: [res.date_end || null],
      division_sales_network_id: [res.division_sales_network_id || null],
      country_id: [res.country_id || null],
      description: [res.description || null],
      email: [res.email || null],
      fax: [res.fax || null],
      host_code: [res.host_code || null],
      latitude: [res.latitude || null],
      longitude: [res.longitude || null],
      name: [res.name || null],
      note_1: [res.note_1 || null],
      note_2: [res.note_2 || null],
      note_3: [res.note_3 || null],
      province_id: [res.province_id || null],
      short_name: [res.short_name || null],
      state_id: [res.state_id || null],
      telephone_1: [res.telephone_1 || null],
      telephone_2: [res.telephone_2 || null],
      telephone_3: [res.telephone_3 || null],
      toponym_id: [res.toponym_id || null],
      zip_code: [res.zip_code || null],
      store_surface: [res.store_surface || null],
      checkouts_number: [res.checkouts_number || null]
    });

    if (this.editMode) {
      this.formBasic.get('code').disable({onlySelf: true});
    }
  }

  setDefaultDateStart() {
    if (!!this.formBasic.controls.date_start.value) {
      return this.formBasic.controls.date_start.value;
    } else {
      return null;
    }
  }

  setDefaultDateEnd() {
    if (!!this.formBasic.controls.date_end.value) {
      return this.formBasic.controls.date_end.value;
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-basic/store-common-basic.component.ts